import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

export const AboutCountryUk = () => {
  const navigate = useNavigate();

  const UkData = {
    title: "Study Abroad Opportunities Uk",
    mTitle: "Why Study in the Uk?",
    desc_1:
      "The United States stands as a global leader in higher education, offering an unparalleled diversity of academic programs and institutions. With its cutting-edge research facilities, innovative teaching methods, and strong support for international students, studying in the Uk opens doors to global opportunities.",
    desc_2:
      "In the Uk, you’ll find not only academic excellence but also a diverse cultural environment, internships, and strong industry ties. It’s more than education—it’s a life experience.",
  };

  const UkBenefits = [
    { title: "World-Class Education", number: 550, suffix: "+" },
    { title: "Diverse Academic Programs", number: 100, suffix: "%" },
    { title: "Top-Ranked Universities", number: 300, suffix: "+" },
    { title: "Strong Industry Connections", number: 550, suffix: "+" },
  ];

  const UkUniversities = [
  { title: "ARU College (Formerly CRIC)", img: "/image/study-abroad/uk/aru-college.png", link: "#" },
  { title: "Bangor University", img: "/image/study-abroad/uk/bangor-university.png", link: "#" },
  { title: "Buckingham New Hampshire University", img: "/image/study-abroad/uk/buckingham-new-hampshire-university.png", link: "#" },
  { title: "Canterbury Christ Church University", img: "/image/study-abroad/uk/canterbury-christ-church-university.png", link: "#" },
  { title: "De Montfort University", img: "/image/study-abroad/uk/de-montfort-university.png", link: "#" },
  { title: "European School of Economics", img: "/image/study-abroad/uk/european-school-of-economics.png", link: "#" },
  { title: "Leeds Beckett University", img: "/image/study-abroad/uk/leeds-beckett-university.png", link: "#" },
  { title: "London Metropolitan University", img: "/image/study-abroad/uk/london-metropolitan-university.png", link: "#" },
  { title: "LSBU (London South Bank University)", img: "/image/study-abroad/uk/lsbu.jpg", link: "#" },
  { title: "Middlesex University London", img: "/image/study-abroad/uk/middlesex-university-london.png", link: "#" },
  { title: "Northumbria University", img: "/image/study-abroad/uk/northumbria-university.png", link: "#" },
  { title: "Ravensbourne University", img: "/image/study-abroad/uk/ravensbourne-university.png", link: "#" },
  { title: "Teesside University", img: "/image/study-abroad/uk/teesside-university.png", link: "#" },
  { title: "Ulster University", img: "/image/study-abroad/uk/ulster-university.png", link: "#" },
  { title: "University College Birmingham", img: "/image/study-abroad/uk/university-college-birmingham.jpg", link: "#" },
  { title: "University of Brighton", img: "/image/study-abroad/uk/university-of-brighton.png", link: "#" },
  { title: "University of Chester", img: "/image/study-abroad/uk/university-of-chester.png", link: "#" },
  { title: "University of Cumbria", img: "/image/study-abroad/uk/university-of-cumbria.png", link: "#" },
  { title: "University of East London", img: "/image/study-abroad/uk/university-of-east-london.png", link: "#" },
  { title: "University of Greenwich", img: "/image/study-abroad/uk/university-of-greenwich.png", link: "#" },
  { title: "University of Portsmouth", img: "/image/study-abroad/uk/university-of-portsmouth.png", link: "#" },
  { title: "University of Wales Trinity Saint David", img: "/image/study-abroad/uk/university-of-wales-trinity-saint-david.png", link: "#" },
  { title: "University of West London", img: "/image/study-abroad/uk/university-of-west-london.png", link: "#" },
];



  const responsiveCarousel = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
    tablet: { breakpoint: { max: 1024, min: 600 }, items: 2 },
    mobile: { breakpoint: { max: 600, min: 0 }, items: 1 },
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
        <style>
        {`
          .react-multiple-carousel__arrow {
            margin-left: -45px;
            margin-right: -45px;
          }
          
        `}
      </style>

      {/* Hero Section */}
      <section className="mb-12">
        <h1 className="text-4xl font-bold text-indigo-700 mb-6">
          {UkData.title}
        </h1>

        {/* Carousel After Main Title */}
        <div className="mb-10 mt-10">
<h3 className="text-2xl font-semibold text-indigo-600 mb-5 mt-5">Top Universities in the Uk</h3>
        <p className="text-gray-600 mb-6 mt-5">Explore Our Partner Institutions</p>

             <Carousel
            responsive={responsiveCarousel}
            infinite
            autoPlay
            autoPlaySpeed={4000}
            arrows
            keyBoardControl
            showDots={false}
            containerClass="carousel-container-custom"
            itemClass="px-3"
            renderButtonGroupOutside={false}
          >
            {UkUniversities.map((univ, idx) => {
              const content = (
                <div className="bg-white mt-10 rounded-lg shadow hover:shadow-lg transition-all duration-300 p-4 text-center h-full flex flex-col items-center justify-between">
                  <img
                    src={univ.img}
                    alt={univ.title}
                    className="rounded-md max-h-36 w-full object-contain mb-3"
                    loading="lazy"
                  />
                  <h5 className="text-sm font-medium text-gray-700">{univ.title}</h5>
                </div>
              );
              return univ.link ? (
                <Link key={idx} to={univ.link}>
                  {content}
                </Link>
              ) : (
                <div key={idx}>{content}</div>
              );
            })}
          </Carousel>

        </div>

        {/* Rest of the Section */}
        <h2 className="text-2xl text-indigo-600 font-semibold mb-4">{UkData.mTitle}</h2>
        <p className="text-gray-700 mb-3 leading-relaxed">{UkData.desc_1}</p>
        <p className="text-gray-700 leading-relaxed">{UkData.desc_2}</p>
               
         <img
          src="/image/about/about-07/uk.png"
          alt="Study in UK"
          className="w-[30%] h-[30%] mx-auto mt-6 rounded-lg object-cover shadow"
        />
      </section>

      {/* Features Section */}
      <section className="mb-16">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">Key Benefits of Studying in the Uk</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {UkBenefits.map((item, idx) => (
            <div key={idx} className="bg-white p-6 rounded-xl shadow-md text-center border border-gray-100">
              <div className="text-3xl font-bold text-indigo-600">
                {item.number}
                {item.suffix}
              </div>
              <p className="mt-2 text-lg font-medium text-gray-700">{item.title}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <div className="text-center mt-12">
        <button
          onClick={() => navigate("/contact-us")}
          className="bg-indigo-600 text-white px-6 py-3 rounded-lg text-lg font-semibold hover:bg-indigo-700 transition"
        >
          Apply Now!
        </button>
      </div>
    </div>
  );
};

export default AboutCountryUk;
